import { render, staticRenderFns } from "./ViewerComponent.vue?vue&type=template&id=5ae8db58&"
import script from "./ViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports